import { render, staticRenderFns } from "./dashboard-counters.vue?vue&type=template&id=9b002ecc&scoped=true"
import script from "./dashboard-counters.vue?vue&type=script&lang=js"
export * from "./dashboard-counters.vue?vue&type=script&lang=js"
import style0 from "./dashboard-counters.vue?vue&type=style&index=0&id=9b002ecc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b002ecc",
  null
  
)

export default component.exports